import React from 'react'

import { Resource } from '@LTIDashboard/modules/GeneralDashboard/Resources'

export function Resources({ resources }) {
  return (
    <React.Fragment>
      {resources.map(item => {
        return <Resource key={item.pk} data={item} />
      })}
    </React.Fragment>
  )
}
